import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import moment from 'moment';

const ProfileEducation = ({
  education: {
    school,
    degree,
    location,
    fieldofstudy,
    current,
    to,
    from,
    description
  }
}) => (
  <div className="credential">
    <div className="card-body">
      <h6 className="">
        <i className="fas fa-graduation-cap"></i> {school}{' '}
      </h6>
      <span className="text-muted location">&#8226; {location}</span>

      <p className="degree">
        {degree} Degree{fieldofstudy && <span>, {fieldofstudy}</span>}
      </p>

      <p className="years">
        <Moment format="YYYY">{moment.utc(from)}</Moment> -{' '}
        {to === null ? (
          ' Present'
        ) : (
          <Moment format="YYYY">{moment.utc(to)}</Moment>
        )}{' '}
      </p>
    </div>
  </div>
);

ProfileEducation.propTypes = {
  education: PropTypes.object.isRequired
};

export default ProfileEducation;
